import { ReactNode } from "react";
import { Box, LinearProgress } from "@material-ui/core";
import useFirestore from "hooks/useFirestore";
import FeatureBlockedNotice from "components/FeatureBlockedNotice";
import type { AdvancedFeature } from "../@types/sharedSchema";

type FeatureGateProps = {
  feature?: AdvancedFeature;
  /**
   * OR-gate: pass when a surface belongs to more than one world — e.g. the blocked-numbers and
   * audiences pages serve both the CRM and the official-WhatsApp features, and a customer holding
   * either must reach them. Exactly one of `feature` / `anyOf` should be given.
   */
  anyOf?: AdvancedFeature[];
  children: ReactNode;
};

export default function FeatureGate({ feature, anyOf, children }: FeatureGateProps) {
  const { userSettings, isLoadingUser } = useFirestore();

  if (isLoadingUser || !userSettings) {
    return (
      <Box my={4} p={2} sx={{ width: "100%" }}>
        <LinearProgress />
      </Box>
    );
  }

  const wanted = anyOf ?? (feature ? [feature] : []);
  const hasFeature = wanted.some((f) => userSettings.advancedFeatures?.includes(f) ?? false);

  if (!hasFeature) {
    return <FeatureBlockedNotice />;
  }

  return <>{children}</>;
}
